import * as Sentry from '@sentry/browser';
import config from 'App/babel/config';

type UpsalesException = {
	status?: number;
	data?: { error?: { key?: string; translated?: string } };
};

const SENTRY = config.SENTRY;

window.SENTRY_ENABLED = SENTRY.enable;

const sentryOptions: Sentry.BrowserOptions = {
	dsn: SENTRY.dsn,
	environment: SENTRY.env,
	release: process.env.SENTRY_RELEASE,
	allowUrls: SENTRY.allowUrls,
	denyUrls: SENTRY.denyUrls,
	ignoreErrors: [
		'Network Error',
		'NetworkError',
		'State changed',
		'escaped',
		'Non-Error promise rejection captured with value: undefined',
		'timeout of 0ms exceeded',
		'ResizeObserver loop limit exceeded' // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
	],
	beforeSend(sentryEvent, hint) {
		const originalException = hint?.originalException as UpsalesException | null | undefined;
		if (originalException && (originalException.status === 401 || originalException.status === -1)) {
			// Discard 401 and -1 errors served from a custom event
			return null;
		}

		if (originalException?.data?.error?.key === 'FailedValidation' && originalException?.data?.error?.translated) {
			// Skipp FailedValidation events that have a translation. Those are known and we do show an error to the user
			return null;
		}

		if (!sentryEvent.user || !sentryEvent.user.id) {
			// Discard messages non logged in users
			return null;
		}

		const serialized = sentryEvent.extra?.__serialized__ as UpsalesException | undefined;
		if (serialized && (serialized.status === 401 || serialized.status === -1)) {
			// Discard 401 errors and custom object errors
			return null;
		}

		return sentryEvent;
	},
	beforeBreadcrumb(breadcrumb, hint) {
		if (breadcrumb.category?.startsWith('ui')) {
			const target = hint?.event?.target as HTMLElement | undefined;
			let text = target?.textContent || target?.innerText;
			if (text) {
				if (text.length > 100) {
					text = text.substring(0, 100) + '...';
				}
				breadcrumb.message += ` > "${text.trim()}"`;
			}
		}
		return breadcrumb;
	}
};

if (!SENTRY.enable) {
	sentryOptions.sampleRate = 0.0;
}

Sentry.init(sentryOptions);
